import Navigation from "./partials/navigation";
import Home from "./pages/home";
import Property from "./pages/property";
import Global from "./global";
import Contact from "./pages/contact";
import Faq from "./pages/faq";

// require('./bootstrap');

//global
new Global();

//partials
new Navigation();

//pages
new Home();
new Faq();
new Property();
new Contact();
